import React, { useState, useEffect } from 'react';
import { Select, Spin, Tag } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import campaignService from '../services/campaignService';
import { useAuth } from '../utils/auth';

const { Option } = Select;

const CAMPAIGN_TYPES = {
  PROMOTION: { label: '促销', color: 'red' },
  ONGOING: { label: '常驻', color: 'blue' },
  EVENT: { label: '活动', color: 'purple' },
};

const CampaignSelector = ({ value, onChange, style }) => {
  const { tenant } = useAuth();
  const tenantId = tenant?.id;
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (tenantId) fetchCampaigns();
  }, [tenantId]);

  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const response = await campaignService.getActiveCampaigns(tenantId);
      if (response.success) setCampaigns(response.data || []);
    } catch (error) {
      console.error('获取活动列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      placeholder="选择活动（可选）"
      allowClear
      showSearch
      filterOption={(input, option) => option.children?.toString().toLowerCase().includes(input.toLowerCase())}
      value={value}
      onChange={onChange}
      loading={loading}
      style={style}
      suffixIcon={<GiftOutlined />}
      notFoundContent={loading ? <Spin size="small" /> : '暂无活动'}
    >
      {campaigns.map(c => {
        const typeConfig = CAMPAIGN_TYPES[c.campaignType] || {};
        return (
          <Option key={c.id} value={c.id}>
            {typeConfig.label && <Tag color={typeConfig.color} style={{ marginRight: 4 }}>{typeConfig.label}</Tag>}
            {c.name}
          </Option>
        );
      })}
    </Select>
  );
};

export default CampaignSelector;
